// Función para cargar dinámicamente los archivos CSS y JS de Stencil
export const loadStencilComponents = (baseUrl) => {
    const script = document.createElement("script");
    script.type = "module";
    // script.src = `${baseUrl}/payments/components/payment-gateway.esm.js`;
    script.src = `${baseUrl}/payment-gateway.esm.js`;
    
    script.onload = () => {
      console.log("payment-gateway.esm.js cargado correctamente");
      if (window.defineCustomElements) {
        window.defineCustomElements(window);
      }
    };
  
    script.onerror = () => {
      console.error("Error al cargar payment-gateway.esm.js");
    };
  
    document.body.appendChild(script);
  
    // Cargar la versión sin módulos para navegadores más antiguos
    const scriptNoModule = document.createElement("script");
    scriptNoModule.setAttribute("nomodule", "");
    // scriptNoModule.src = `${baseUrl}/payments/components/payment-gateway.js`;
   scriptNoModule.src = `${baseUrl}/payment-gateway.js`;

  
    scriptNoModule.onload = () => {
      if (window.defineCustomElements) {
        window.defineCustomElements(window);
      }
    };
  
    scriptNoModule.onerror = () => {
      console.error("Error al cargar payment-gateway.js");
    };
  
    document.body.appendChild(scriptNoModule);
  };